// extracted by mini-css-extract-plugin
export default {"indicators":"styles_indicators__M7p86","active":"styles_active__4fxBu"};